import api from './api'

export const eventQuizAPI = {
  getAll: () => api.get('/event-quiz'),
  getById: (id) => api.get(`/event-quiz/${id}`),
  create: (data) => api.post('/event-quiz', data),
  update: (id, data) => api.put(`/event-quiz/${id}`, data),
  delete: (id) => api.delete(`/event-quiz/${id}`),
  startSession: (id) => api.post(`/event-quiz/${id}/start`),
  getJoinInfo: (code) => api.get(`/event-quiz/join/${code}`),
  join: (code, data) => api.post(`/event-quiz/join/${code}`, data),
  getSession: (sessionId) => api.get(`/event-quiz/session/${sessionId}`),
  exportResults: (sessionId, format = 'json') =>
    api.get(`/event-quiz/session/${sessionId}/export`, {
      params: { format },
      responseType: format === 'csv' ? 'blob' : 'json'
    }),
}

export default eventQuizAPI
